<div class="scenario-activity-container">
  <!-- Empty state -->
  <div class="empty-state" *ngIf="activities.length === 0">
    <mat-icon class="empty-icon">hourglass_empty</mat-icon>
    <span class="empty-text">No active operations</span>
  </div>

  <!-- Activity table -->
  <table class="activity-table" *ngIf="activities.length > 0">
    <thead>
      <tr>
        <th class="col-user">User</th>
        <th class="col-operation">Operation</th>
        <th class="col-queue">Queue</th>
        <th class="col-status">Status</th>
        <th class="col-duration">Duration</th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let row of activities; trackBy: trackByEventSourceId"
        [class.completing]="row.completing"
        [class.removing]="row.removing"
      >
        <td class="col-user">
          <div class="user-cell">
            <span
              class="avatar"
              [style.background-color]="getAvatarColor(row.userName)"
            >
              {{ getInitials(row.userName) }}
            </span>
            <span class="user-name" [title]="row.userName">{{ row.userName }}</span>
          </div>
        </td>
        <td class="col-operation">
          <span class="operation-text" [title]="row.commandTitle">{{ row.commandTitle }}</span>
        </td>
        <td class="col-queue">
          <div class="queue-cell">
            <div class="progress-bar-track">
              <div
                class="progress-bar-fill"
                [style.width.%]="row.progressPercent"
                [style.background-color]="row.progressColor"
              ></div>
            </div>
            <span class="remaining-text">{{ row.remaining }} left</span>
          </div>
        </td>
        <td class="col-status">
          <span class="status-pill" [ngClass]="getStatusClass(row.status)">
            {{ row.status }}
          </span>
        </td>
        <td class="col-duration">
          <span class="duration-text">{{ row.durationDisplay }}</span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
